import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { ValidationService } from '../../../../../shared/_services/validation.service';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';
import { HcaBookingService } from '../../../../../shared/_services/hca-booking.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService } from '../../../../../shared/_services/util.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-bookings-modify',
  templateUrl: './bookings-modify.component.html',
  styleUrls: ['./bookings-modify.component.scss']
})
export class BookingsModifyComponent implements OnInit {
  bookingForm: FormGroup;
  bookingId: number;
  searchedBookings: any[] = [];
  searchedTransactions: any[] = [];
  isSelectedBooking: boolean = false;
  transactionTerm$ = new Subject<string>();
  isTransactionError : boolean = false;
  private unsubscribe: Subject<void> = new Subject<void>();
  bsConfig: Partial<BsDatepickerConfig> = { containerClass: 'theme-orange' };
  filterLookUpData: any;
  transactionData: any;
  bookingDetails: any;
  previousRoute: any;
  statusModal: BsModalRef;
  successMsg: string;
  errorMsg: any;
  p: number = 0;
  totalCount: number;
  transactionList: any[];
  size: number = 10;
  isNewPmsMigration: boolean = false;
  editableReferralCodeField: boolean = false;
  canHardDelete = false;

  currencies = [
    {id: 'MXN', name: 'MXN'},
    {id: 'USD', name: 'USD'},
    {id: 'EUR', name: 'EUR'}
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private modalService: BsModalService,
    private hcaBookingService: HcaBookingService,
    private validationService: ValidationService,
  ) {
    this.hcaBookingService.search(this.transactionTerm$)
    .subscribe(res => {
      if (res.error == 0) {
        this.isSelectedBooking = true;
        this.searchedTransactions = res.responseObj;
        if(this.searchedTransactions && this.searchedTransactions.length && this.searchedTransactions.indexOf(this.bookingForm.get('transactionId').value) == -1) {
          this.isTransactionError = true;
        } else {
          if(this.bookingForm.get('transactionId').value) {
            this.isTransactionError = true;
          } else {
            this.isTransactionError = false;
          }
        }
      }
    }, err => {
      this.searchedTransactions = [];
    });

    this.modalService.onHide
    .takeUntil(this.unsubscribe)
    .subscribe(res => {
      if (!this.statusModal || !this.statusModal.content || !this.statusModal.content.srcObject) {
        return;
      }
      const src = this.statusModal.content.srcObject;
      if (src.action != "action1" || !src.type) {
        return;
      }
      if (src.type == "employee") {
        if (src.status || src.status == 0) {
          this.activateOrDeactivateBooking(src.id, +src.status);
        } else {
          this.location.back();
          this.hcaBookingService.bookingDetails = null;
        }
      } else if (src.type == "stay-hard-delete" && src.id) {
        this.hardDeleteStay(src.id);
      }
      this.statusModal = null;
    })
  }

  activateOrDeactivateBooking(bookingIds, status) {
   this.hcaBookingService.activateOrDeactivateBooking(bookingIds, status).subscribe(res => {
     if (res.error == 0) {
      this.location.back();
      this.hcaBookingService.bookingDetails = null;
     }
   }, err => {
     console.error('Error Activating/Deactivating Booking: ', err.message);
   })
 }

  openStatusModal(id?, mode?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = mode == 0 ? "Are you sure you want to deactivate this Booking?" : "Are you sure you want to activate this Booking?";
    let title = mode == 0 ? "Deactivate Booking" : "Activate Booking";
    let action1 = mode == 0 ? "Deactivate" : "Activate";
    let style = mode == 0 ? "inactive" : "active";
    let status = mode;
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'employee',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    }
  }

  openHardDeleteStayModal(bookingId) {
    if (!this.canHardDelete || !bookingId) {
      return;
    }
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'stay-hard-delete',
      title: 'Delete Stay Permanently',
      message: 'This will permanently delete this stay. Stays with approved or applied transactions cannot be deleted. This action cannot be undone.',
      id: bookingId,
      action1: 'Delete Permanently',
      action2: 'Cancel',
      action: '',
      style: 'inactive'
    };
  }

  hardDeleteStay(bookingId) {
    this.errorMsg = null;
    this.hcaBookingService.hardDeleteStay(bookingId).subscribe(res => {
      if (res.error === 0) {
        this.location.back();
        this.hcaBookingService.bookingDetails = null;
      } else {
        this.showStayDeleteError(res.message);
      }
    }, err => {
      this.showStayDeleteError(err && err.message ? err.message : 'Error while deleting stay');
    });
  }

  hasHardDeleteAccess(): boolean {
    const user = JSON.parse(localStorage.getItem('loggedInUser'));
    if (!user || !user.token) {
      return false;
    }
    const role = this.utilService.parseJwt(user.token).info.roles;
    return ['ROLE_HCA', 'ROLE_CCS'].indexOf(role) >= 0;
  }

  private showStayDeleteError(message) {
    this.errorMsg = message;
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'stay-delete-error',
      title: 'Cannot delete stay',
      message: message,
      action1: 'OK',
      action2: 'Close',
      action: '',
      style: 'inactive'
    };
  }

  confirmClose() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'employee',
      title: 'Confirm',
      message: !this.bookingId ? "Are you sure you want to cancel adding a new Booking?" : "Do you want to cancel modifying the Booking?",
      status: null,
      action1: 'Yes',
      action2: 'No',
      action: '',
    }
  }

  selectDropdown(id, type) {
    if(type == 'transaction') {
      this.bookingForm.get('transactionId').setValue(id);
        if(this.searchedTransactions.length) {
          if(this.searchedTransactions.indexOf(id) == -1) {
            this.isTransactionError = true;
          } else {
            this.isTransactionError = false;
          }
        }
    }

  }

  goToHotel() {
    this.hcaBookingService.bookingDetails = this.bookingForm.value;
    this.router.navigate(['/hotel-management', 'hotel', 'add']);
  }

  goToBookingTransaction(transactionId) {
    this.router.navigate(['/bookings/edit/'+this.bookingId+'/bookingTransaction/'+transactionId]);
  }

  selectedHotel(hotel) {
    this.bookingForm.get('hotelName').setValue(hotel && hotel.hotelName ? hotel.hotelName : null);
    this.bookingForm.get('hotelId').setValue(hotel && hotel.hotelId ? hotel.hotelId : null);
  }

  getfilterLookUpData() {
    this.hcaBookingService.getLookupDataForBooking().subscribe(res => {
      if (res.error == 0) {
        this.filterLookUpData = res.responseObj;
        this.initForm(this.bookingDetails);
      }
    }, err => {
      console.error('Error while getting filter look up date: ', err.message);
    })
  }

  getTransactionData() {
    this.hcaBookingService.getTransactionList(this.bookingId).subscribe(res => {
      if (res.error == 0) {
        this.transactionData = res.responseObj
      }
    }, err => {
      console.error('Error while getting filter look up date: ', err.message);
    })
  }

  getBookingDetails(bookingId?) {
    this.hcaBookingService.getLoyaltyBookingByBookingId(bookingId).subscribe(res => {
      if (res.error == 0) {
        this.bookingDetails = res.responseObj;
        this.initForm(this.bookingDetails);
        if (res.responseObj.hotelId === 7 || res.responseObj.hotelId === 10
            || res.responseObj.hotelId === 6 || res.responseObj.hotelId === 9
            || res.responseObj.hotelId === 13 || res.responseObj.hotelId === 11) {
          this.isNewPmsMigration = true;
        }
        //this.isNewPmsMigration = true;
      }
    }, err => {
      console.error('Error while fetching Booking Details by Id: ', err.message);
    })
  }

  updateBooking() {
    console.log(this.bookingForm.value);
  }

  addBooking(isReset) {
    let data = this.utilService.dateParser(this.bookingForm.value, ['checkInDate', 'checkOutDate']);
    this.hcaBookingService.saveOrEditLoyaltyBooking(data).subscribe(res => {
      if(res.error == 0) {
        // this.successMsg = res && res.message ? res.message : "Promo added successfully";
        this.successMsg = !this.bookingId ? "Employee has been added successfully" : "Changes made successfully";
        setTimeout(() => {
          this.successMsg = "";
          if (isReset) {
            this.initForm(null);
          } else {
            this.location.back();
            this.hcaBookingService.bookingDetails = null;
          }
      }, 1500);
      }
    },err => {
      this.errorMsg = err && err.message ? err.message : (!this.bookingId ? "Error while creating New Employee" : "Error while updating Employee");
      setTimeout(() => {
        this.errorMsg = "";
      }, 2000);
      console.error('Error while saving/updating benefit data: ', err.message);
    })
  }

  syncWithPms(isReset) {
    let data = this.utilService.dateParser(this.bookingForm.value, ['checkInDate', 'checkOutDate']);
    this.hcaBookingService.syncWithPms(data).subscribe(res => {
      if(res.error == 0) {
        // this.successMsg = res && res.message ? res.message : "Promo added successfully";
        this.successMsg = !this.bookingId ? "Employee has been added successfully" : "Changes made successfully";
        setTimeout(() => {
          this.successMsg = "";
          if (isReset) {
            this.initForm(null);
          } else {
            this.location.back();
            this.hcaBookingService.bookingDetails = null;
          }
      }, 1500);
      }
    },err => {
      this.errorMsg = err && err.message ? err.message : (!this.bookingId ? "Error while creating New Employee" : "Error while updating Employee");
      setTimeout(() => {
        this.errorMsg = "";
      }, 2000);
      console.error('Error while saving/updating benefit data: ', err.message);
    })
  }

  getSelectedStr(length, type) {
    return `${length} ${type}${length !== 1 ? 's' : ''} Selected`;
  }

  checkSelected(isChecked: boolean, controlName, type, valueType, value) {
    let formArray = this.bookingForm.controls[controlName] as FormArray;
    if (isChecked) {
      if (value == 0) {
        while (formArray.value.length !== 0) {
          formArray.removeAt(0)
        }
        formArray.push(new FormControl(0));
        this.filterLookUpData[type].forEach(value => {
          formArray.push(new FormControl(valueType == 'origin' ? value : value[valueType]));
        });
      } else {
        formArray.push(new FormControl(value));
        if (formArray.value.indexOf(0) == -1 && this.filterLookUpData[type].length == formArray.value.length) {
          formArray.push(new FormControl(0));
        }
      }
    } else {
      if (value == 0) {
        while (formArray.value.length !== 0) {
          formArray.removeAt(0)
        }
      } else {
        let index = formArray.controls.findIndex(x => x.value == value);
        if (index > -1) {
          formArray.removeAt(index);
        }
        if (formArray.value.indexOf(0) > -1) {
          if (this.filterLookUpData[type].length != formArray.value.length - 1) {
            let idx = formArray.controls.findIndex(x => x.value == 0);
            if (idx > -1) {
              formArray.removeAt(idx);
            }
          }
        }
      }
    }
  }

  initForm(data?) {
    let pointsTransactionIds = this.fb.array([]);
    let user = JSON.parse(localStorage.getItem('loggedInUser'));
    if(user.userRoleId == 42) {
      this.editableReferralCodeField = true;
    }
    this.bookingForm = this.fb.group({
      bookingId: [data ? data.bookingId : ''],
      locator: [data ? data.locator : '', [Validators.required, Validators.maxLength(60), this.validationService.noWhitespaceValidator]],
      checkInDate: [data && data.checkInDate ? this.utilService.dateFormat(data.checkInDate, 'MM/DD/YYYY') : ''],
      checkOutDate: [data && data.checkOutDate ? this.utilService.dateFormat(data.checkOutDate, 'MM/DD/YYYY') : ''],
      transactionId: [data ? data.transactionId : ''],
      pointsTransactionIds: pointsTransactionIds,
      hotelId: [data ? data.hotelId : null, [Validators.required]],
      hotelName: [data ? data.hotelName : '', []],
      agency: [data ? data.agency : '', [Validators.maxLength(60), this.validationService.noWhitespaceValidator]],
      stayCost: [data ? data.stayCost : '', [Validators.maxLength(12), Validators.required]],
      netCost: [data ? data.netCost : '', [Validators.maxLength(12), Validators.required]],
      extraCost: [data ? data.extraCost : '', [Validators.maxLength(12), Validators.required]],
      currency: [data && data.currency ? data.currency : null],
      adults: [data ? data.adults : '', [Validators.maxLength(6), Validators.required]],
      direct: [data ? data.direct : ''],
      treatmentId: [data ? data.treatmentId : '', [Validators.required]],
      pmsId: [data ? data.pmsId : '', [Validators.maxLength(60), this.validationService.noWhitespaceValidator]],
      pmsEntitler: [data ? data.pmsEntitler : '', [Validators.maxLength(60), this.validationService.noWhitespaceValidator]],
      pmsBonus: [data ? data.pmsBonus : '', [Validators.maxLength(60), this.validationService.noWhitespaceValidator]],
      pmsBookingReference: [data ? data.pmsBookingReference : '', [Validators.maxLength(60), this.validationService.noWhitespaceValidator]],
      state: [data ? data.state : '', [Validators.required]],
      origin: [data ? data.origin : ''],
      referralCode: [data ? data.referralCode : ''],
      comments: [data ? data.comments : ''],
      statusId: [data && data.statusId ? data.statusId : null]
    }, {validator: this.validationService.dateLessThan('checkInDate', 'checkOutDate')});
    this.bookingForm.controls['direct'].valueChanges.subscribe(value => {
      if(value && value == 'Yes') {
        this.bookingForm.controls['stayCost'].setValidators([Validators.required, Validators.max(10000), Validators.min(0), Validators.pattern(this.validationService.isNumber2Decimal_regexPattern)]);
        this.bookingForm.controls['stayCost'].updateValueAndValidity();
      } else {
        this.bookingForm.controls['stayCost'].setValidators(null);
        this.bookingForm.controls['stayCost'].updateValueAndValidity();
      }
    });
    if(data && data.pointsTransactionIds && data.pointsTransactionIds.length && this.filterLookUpData) {
      data.pointsTransactionIds.forEach(transaction => {
        this.checkSelected(true, 'pointsTransactionIds', 'transactions', 'pointTransactionId', transaction)
      });
    }
  }

  ngOnInit() {
    this.canHardDelete = this.hasHardDeleteAccess();
    this.getfilterLookUpData();
    this.initForm();
    this.previousRoute = this.utilService.getPreviousRoute;
    if(this.previousRoute.indexOf('/hotel/') > -1) {
      this.bookingDetails = this.hcaBookingService.bookingDetails;
    } else {
      this.hcaBookingService.bookingDetails = null;
      this.bookingDetails = null;
    }
    this.route.params.subscribe(params => {
      this.bookingId = +params['id']; // (+) converts string 'id' to a number
      this.hcaBookingService.bookingId = this.bookingId;
      if(this.bookingId && !this.bookingDetails) {
        this.getBookingDetails(this.bookingId);
      } else {
        this.initForm(this.bookingDetails)
      }
    })
    this.getTransactionData();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/bookings/bookings-modify/bookings-modify.component.ts